import CheckboxField from "@/components/form/CheckboxField"
import CurrencyField from "@/components/form/CurrencyField"
import DateField from "@/components/form/DateField"
import DynamicPhoneField from "@/components/form/DynamicPhoneField"
import EmailField from "@/components/form/EmailField"
import Form from "@/components/form/Form"
import FormGroup from "./FormGroup"
import NumberField from "@/components/form/NumberField"
import PhoneField from "@/components/form/PhoneField"
import PlusMinusField from "@/components/form/PlusMinusField"
import RadioField from "@/components/form/RadioField"
import SelectField from "@/components/form/SelectField"
import SsnField from "@/components/form/SsnField"
import StateField from "@/components/form/StateField"
import TextField from "@/components/form/TextField"
import ZipCodeField from "@/components/form/ZipCodeField"
import AppField from "@/components/form/AppField"

export default {
    install(Vue) {
        Vue.component("AppField", AppField)
        Vue.component("Form", Form)
        Vue.component("CheckboxField", CheckboxField)
        Vue.component("CurrencyField", CurrencyField)
        Vue.component("DateField", DateField)
        Vue.component("DynamicPhoneField", DynamicPhoneField)
        Vue.component("EmailField", EmailField)
        Vue.component("SelectField", SelectField)
        Vue.component("StateField", StateField)
        Vue.component("TextField", TextField)
        Vue.component("NumberField", NumberField)
        Vue.component("PhoneField", PhoneField)
        Vue.component("PlusMinusField", PlusMinusField)
        Vue.component("RadioField", RadioField)
        Vue.component("SsnField", SsnField)
        Vue.component("FormGroup", FormGroup)
        Vue.component("ZipCodeField", ZipCodeField)
    },
}
